import React from "react";
import { Modal } from "antd";
import { bigStatusIcon } from "../../utils/svgs";
import Button from "../button";
import "../../styles/CustomModal.css";

const TripCloseModal = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  detailLoading = false,
  detailData = null,
  tripContext = null,
  tripIdDisplay = "",
}) => {
  const ctx = tripContext && typeof tripContext === "object" ? tripContext : {};
  // tripContext may be tripDetailsData (nested under .data) or already-unwrapped detailData
  const flat = ctx?.data && typeof ctx.data === "object" ? ctx.data : ctx;
  const trip = detailData?.trip && typeof detailData.trip === "object" ? detailData.trip : flat;

  const tripId =
    trip?.trip_id ||
    flat?.trip_id ||
    ctx?.trip_id ||
    ctx?.data?.trip_id ||
    (tripIdDisplay && !String(tripIdDisplay).startsWith('TR-') ? tripIdDisplay : '') ||
    trip?.tripId ||
    flat?.tripId ||
    trip?.trip_number ||
    flat?.trip_number ||
    tripIdDisplay ||
    (trip?.id ? (String(trip.id).startsWith('TR-') ? trip.id : `TR-${trip.id}`) : '');

  return (
    <Modal
      footer={null}
      title={
        <div className="d-flex align-items-center gap-2">
          <span className="trip_close_report_title_icon">{bigStatusIcon}</span>
          <span className="trip_close_report_title_text">Close Trip</span>
        </div>
      }
      open={open}
      onCancel={onClose}
      centered
      destroyOnClose
      maskClosable={false}
      className="trip_close_custom_modal"
    >
      <div className="trip_close_report_view">
        <h4 className="trip_close_confirm_text">
          Are you sure you want to close trip {tripId ? <strong>{tripId}</strong> : "this trip"}?
        </h4>
        <p className="trip_close_subtext">
          This action will finalize the trip settlement, change its stage to Closed, and proceed to Invoicing.
        </p>

        <div className="trip_close_report_actions mt-4 d-flex justify-content-end gap-2">
          <Button
            cancelBtn={onClose}
            cancelBtnText="Cancel"
            cancelBtnDisabled={loading}
            submitBtn={onConfirm}
            submitText={loading ? "Closing..." : "Close Trip"}
            loading={loading}
            disabled={loading || detailLoading}
            isShowSubmitBtn
            shouldRow={false}
            buttonExtraCss="trip_close_modal_submit_btn"
          />
        </div>
      </div>
    </Modal>
  );
};

export default TripCloseModal;
